export class TempleMember {
    address: string;
    createdBy: number;
    email: string;
    id: number;
    dob: string;
    isMember: boolean;
    memberId: number;
    name: string;
    personalId: number;
    phone: string;
    templeId: number;
    templeName: string;
    type: number;
  
    image: string;
    file: any;
    expired: boolean;
    nomineeNo: string;
    nomineeId: number;
    nomineeRelation: string;
     isExpired?: boolean;
      isActive?: boolean;
}
export class MemberRequest {
    constructor(public address?: string,public status?:string,
        public email?: string, public dob ?: string,public star?:string,
        public isMember?: boolean,
        public name?: string,public nomineeId?: number,public relation?:string,
        public phone?: string, public id?: number, public type?: string, 
        public typeId?: number, public memberId?: number,
        public isExpired?: boolean, public isActive?: boolean,public nomineeNo?: string) { }
}
export class MemberType {
    constructor(public memberType: string, public prefix?: string) { }
}
export class MemberList {
    constructor(public typeWiseId?: any, public list?: TempleMember[], public totalElements?: number) { }
}
